import CONFIG from "../../config";
import { EdelmetallOrder } from "./EdelmetallOrder";
import { SortenOrder } from "./SortenOrder";


export const Order = CONFIG.getShopConfig({
  edelmetall: EdelmetallOrder,
  sorten: SortenOrder
});
